import React from 'react';
import Button from '@material-ui/core/Button';
import { __ } from '@wordpress/i18n';

// 画面を表示できなかったときに、本文の領域に出す表示。チャンクを読み込めなかったときのほか、
// 画面の中で例外が起きたときにも出る
const PageLoadError: React.FC = () => (
  <div
    role="alert"
    style={{
      minHeight: '320px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
    }}
  >
    <p>{__('This page could not be displayed.')}</p>
    <Button variant="contained" onClick={() => window.location.reload()}>
      {__('Reload page')}
    </Button>
  </div>
);

export default PageLoadError;
